import { useRef, useState } from 'react';
import { ChevronRight, ShieldCheck, Upload } from 'lucide-react';

export const acceptedPrintFiles = '.png,.jpg,.jpeg,.webp,.stl,.3mf,.gcode,.gco';

function firstFile(event) {
  return event.dataTransfer?.files?.[0] || event.target?.files?.[0] || null;
}

export default function UploadStarter({ onFile, onManualEntry, compact = false }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const chooseFile = () => inputRef.current?.click();

  const handleFile = (event) => {
    event.preventDefault?.();
    setDragging(false);
    const file = firstFile(event);
    if (file) onFile?.(file);
    if (event.target) event.target.value = '';
  };

  return (
    <>
      <input
        ref={inputRef}
        className="visually-hidden"
        type="file"
        accept={acceptedPrintFiles}
        onChange={handleFile}
      />
      <button
        className={`drop-zone ${dragging ? 'drop-zone--dragging' : ''} ${compact ? 'drop-zone--compact' : ''}`}
        type="button"
        onClick={chooseFile}
        onDragEnter={(event) => { event.preventDefault(); setDragging(true); }}
        onDragOver={(event) => { event.preventDefault(); event.dataTransfer.dropEffect = 'copy'; setDragging(true); }}
        onDragLeave={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget)) setDragging(false);
        }}
        onDrop={handleFile}
      >
        <span className="drop-zone__icon"><Upload size={27} /></span>
        <strong>{dragging ? 'Release to start the estimate' : 'Drop a file or browse'}</strong>
        <span>Slicer screenshot, STL, 3MF, or G-code</span>
        <div className="file-pills"><small>PNG</small><small>JPG</small><small>STL</small><small>3MF</small><small>GCODE</small></div>
      </button>
      {!compact && (
        <div className="upload-card__footer">
          <span><ShieldCheck size={16} /> OCR and model analysis run on this device</span>
          <button type="button" onClick={onManualEntry}>Use manual entry <ChevronRight size={16} /></button>
        </div>
      )}
    </>
  );
}
